import { Subscription } from 'rxjs';

export class SubscriptionsManager {
  private subscriptions: Subscription = new Subscription();

  add(subscription: Subscription): void {
    this.subscriptions.add(subscription);
  }

  unsubscribeAll(): void {
    this.subscriptions.unsubscribe();
  }
}
